export const TERMS_INTRO = [
    'Администратор установил правила использования Сайта.',
    'Правила Сайта являются публичной офертой и представляют собой предложение Администратора Пользователю заключить договор на указанных ниже условиях.',
    'Договор считается заключенным с момента Акцепта и действует в течение срока использования Сайта. Акцепт Правил означает их полное и безоговорочное принятие. В случае несогласия с Правилами Пользователь не должен совершать Акцепт.',
];

export const TERMS_DEFINITIONS = [
    {
        term: 'Администратор',
        text: 'Хамдохов А.Р., ИНН 070709952572, являющийся владельцем Сайта.',
    },
    {
        term: 'Сайт',
        text: 'веб-сайт BypassVPN (bypass-vpn.ru), предназначенный для передачи Ключа доступа к виртуальной частной сети через личный кабинет Пользователя.',
    },
    {
        term: 'Контент',
        text: 'созданные творческим трудом текстовые, графические и иные материалы, размещенные Администратором на Сайте.',
    },
    {
        term: 'Ключ доступа',
        text: 'зашифрованный цифровой ключ, используемый для активации виртуальной частной сети.',
    },
    {
        term: 'Пользователь',
        text: 'любое лицо, использующее Сайт и совершившее Акцепт.',
    },
    {
        term: 'Акцепт',
        text: 'регистрация на Сайте и создание личного кабинета Пользователем.',
    },
    {
        term: 'Подписка',
        text: 'использование Пользователем платной версии Сайта в пределах, сроки и за вознаграждение, указанные в Тарифе.',
    },
    {
        term: 'Период подписки',
        text: 'срок использования Сайта, в зависимости от выбранного Тарифа.',
    },
    {
        term: 'Тариф',
        text: 'вознаграждение Администратора, соответствующее определенному объему прав на Сайт и сроку их предоставления Пользователю. Перечень, стоимость и содержание Тарифов указаны на Сайте.',
    },
    {
        term: 'Политика',
        text: 'Политика конфиденциальности Администратора, размещенная на Сайте.',
    },
];

export const TERMS_SECTIONS = [
    {
        id: 'section-1',
        title: '1. Предмет',
        blocks: [
            {
                type: 'p',
                text: 'Администратор предоставляет доступ к Сайту и лицензию на его использование, а Пользователь выплачивает за это вознаграждение по выбранному Тарифу.',
            },
        ],
    },
    {
        id: 'section-2',
        title: '2. Доступ к Сайту',
        blocks: [
            {
                type: 'clause',
                id: '2.1',
                text: 'Для получения доступа к Сайту Пользователь проходит регистрацию на Сайте и создает личный кабинет.',
            },
            {
                type: 'clause',
                id: '2.2',
                text: 'Доступ к функциям Сайта активируется после оплаты стоимости выбранного Тарифа в личном кабинете. Период подписки начинается в день оплаты.',
            },
            {
                type: 'clause',
                id: '2.3',
                text: 'Все действия Пользователя на Сайте считаются совершенными им.',
            },
        ],
    },
    {
        id: 'section-3',
        title: '3. Интеллектуальная собственность',
        blocks: [
            {
                type: 'clause',
                id: '3.1',
                text: 'Исключительные права на Сайт и Контент принадлежат Администратору.',
            },
            {
                type: 'clause',
                id: '3.2',
                text: 'Администратор предоставляет Пользователю неисключительную, отзывную лицензию на использование Сайта и Контента на территории всего мира.',
            },
            {
                type: 'clause',
                id: '3.3',
                text: 'Пользователь вправе использовать Сайт и Контент для:',
            },
            { type: 'clause', id: '3.3.1', text: 'доступа к Сайту через веб-браузер;' },
            { type: 'clause', id: '3.3.2', text: 'просмотра Контента и ознакомления с ним;' },
            { type: 'clause', id: '3.3.3', text: 'оплаты и получения Ключа доступа в личном кабинете.' },
            {
                type: 'clause',
                id: '3.4',
                text: 'Использование Сайта и Контента другими способами разрешено только с письменного согласия Администратора и в пределах, указанном в данном согласии.',
            },
            {
                type: 'clause',
                id: '3.5',
                text: 'Лицензия предоставляется на срок использования Сайта и Контента.',
            },
            {
                type: 'clause',
                id: '3.6',
                text: 'Администратор вправе модифицировать Сайт в период действия лицензии.',
            },
        ],
    },
    {
        id: 'section-4',
        title: '4. Финансовые условия',
        blocks: [
            { type: 'subheading', text: 'Стоимость Подписки' },
            {
                type: 'clause',
                id: '4.1',
                text: 'Стоимость Подписки указана в соответствующем Тарифе на Сайте.',
            },
            {
                type: 'clause',
                id: '4.1.1',
                text: 'Администратор вправе в одностороннем порядке изменять стоимость Тарифа, при этом стоимость уже оплаченной Подписки остается неизменной.',
            },
            {
                type: 'clause',
                id: '4.1.2',
                text: 'Вознаграждение не облагается НДС в связи с применением Администратором УСН.',
            },
            { type: 'subheading', text: 'Порядок оплаты' },
            {
                type: 'clause',
                id: '4.2',
                text: 'Пользователь оплачивает Подписку любым из способов, указанных в соответствующем разделе Сайта.',
            },
            {
                type: 'clause',
                id: '4.3',
                text: 'Администратор взимает плату за Подписку в виде полной предоплаты.',
            },
            {
                type: 'clause',
                id: '4.3.1',
                text: 'Подписка предоставляется разово, без автопродления.',
            },
            {
                type: 'clause',
                id: '4.4',
                text: 'Расчеты производятся в безналичной форме в российских рублях.',
            },
            {
                type: 'clause',
                id: '4.5',
                text: 'После оплаты Пользователь получает один кассовый чек по признаку «Полный расчет».',
            },
            {
                type: 'clause',
                id: '4.6',
                text: 'Подписка считается оплаченной с момента поступления денежных средств на расчетный счет Администратора.',
            },
            {
                type: 'clause',
                id: '4.7',
                text: 'Подписка считается неоплаченной, если Администратор вернул денежные средства по требованию платежной организации. В таком случае Администратор вправе отказать Пользователю в доступе к Подписке с момента возврата денежных средств.',
            },
            { type: 'subheading', text: 'Прекращение Подписки' },
            {
                type: 'clause',
                id: '4.8',
                text: 'Неиспользование Подписки по любым причинам не является основанием для возврата уплаченной суммы.',
            },
            { type: 'subheading', text: 'Правовое основание' },
            {
                type: 'p',
                text: 'Согласно ч. 4 ст. 453 ГК РФ Стороны не вправе требовать возвращения того, что было исполнено по обязательству. Обязательство Администратора по активации Подписки считается исполненным в момент передачи Пользователю Ключа доступа в личном кабинете на Сайте.',
            },
            {
                type: 'p',
                text: 'К правоотношениям между Администратором и Пользователем применяются положения Гражданского кодекса об исполнении обязательств по требованию в соответствии со ст. 429.4 ГК РФ. В связи с этим, если Пользователь не воспользовался Подпиской, он не вправе требовать от Администратора возврата денежных средств за неизрасходованный период Подписки.',
            },
        ],
    },
    {
        id: 'section-5',
        title: '5. Гарантии Пользователя',
        blocks: [
            {
                type: 'clause',
                id: '5.1',
                text: 'Пользователь гарантирует, что:',
            },
            {
                type: 'clause',
                id: '5.1.1',
                text: 'является дееспособным физическим лицом, самозанятым, индивидуальным предпринимателем или юридическим лицом;',
            },
            {
                type: 'clause',
                id: '5.1.2',
                text: 'обладает необходимыми правами для совершения Акцепта и выполнения любых других действий на Сайте;',
            },
            {
                type: 'clause',
                id: '5.1.3',
                text: 'предоставил полную и достоверную информацию о себе;',
            },
            {
                type: 'clause',
                id: '5.1.4',
                text: 'обладает необходимыми полномочиями для выполнения действий на Сайте, если Пользователь действует от имени и по поручению индивидуального предпринимателя или юридического лица;',
            },
            {
                type: 'clause',
                id: '5.1.5',
                text: 'банковская карта, с помощью которой осуществляется оплата Подписки, принадлежит Пользователю или используется им с письменного разрешения владельца данной карты.',
            },
        ],
    },
    {
        id: 'section-6',
        title: '6. Запрещенные действия',
        blocks: [
            {
                type: 'clause',
                id: '6.1',
                text: 'Пользователю запрещается:',
            },
            { type: 'clause', id: '6.1.1', text: 'передавать Ключ доступа третьим лицам;' },
            {
                type: 'clause',
                id: '6.1.2',
                text: 'выдавать себя за другое лицо, его представителя, в том числе за Администратора или его сотрудников, а также применять любые другие способы незаконного представительства;',
            },
            { type: 'clause', id: '6.1.3', text: 'проявлять неуважение к Администратору;' },
            {
                type: 'clause',
                id: '6.1.4',
                text: 'копировать, продавать, а также создавать составные и/или производные произведения на основе Сайта;',
            },
            {
                type: 'clause',
                id: '6.1.5',
                text: 'предпринимать действия, направленные на дестабилизацию работы Сайта, в том числе использовать эксплойты и другие вредоносные программы;',
            },
            {
                type: 'clause',
                id: '6.1.6',
                text: 'изменять, эмулировать, декомпилировать, дизассемблировать, дешифровать, производить реверс-инжиниринг и иные действия с исходным и объектным кодом Сайта;',
            },
            {
                type: 'clause',
                id: '6.1.7',
                text: 'предпринимать попытки обойти технические ограничения, установленные Сайтом;',
            },
            {
                type: 'clause',
                id: '6.1.8',
                text: 'редактировать или удалять информацию о правообладателе Сайта;',
            },
            { type: 'clause', id: '6.1.9', text: 'использовать Сайт для достижения противоправных целей.' },
        ],
    },
    {
        id: 'section-7',
        title: '7. Ответственность Сторон',
        blocks: [
            {
                type: 'clause',
                id: '7.1',
                text: 'При неисполнении или ненадлежащем исполнении обязательств Стороны несут ответственность согласно Правилам и законодательству Российской Федерации.',
            },
            {
                type: 'clause',
                id: '7.2',
                text: 'Пользователь самостоятельно несет ответственность и берет на себя все риски по использованию Сайта для анонимизации своей активности в интернете и получения доступа к информационным ресурсам, запрещенным на территории Российской Федерации.',
            },
            {
                type: 'clause',
                id: '7.2.1',
                text: 'Поскольку на Сайте не применяются автоматизированные методы мониторинга, осуществляющие трекинг действий Пользователя, Администратор не имеет технических возможностей для выявления подобных нарушений и их своевременного блокирования.',
            },
            {
                type: 'clause',
                id: '7.3',
                text: 'В случае нарушения гарантий Пользователем Администратор вправе взыскать штрафную неустойку в размере 50 000 рублей за каждый случай нарушения.',
            },
            {
                type: 'clause',
                id: '7.4',
                text: 'В случае нарушения интеллектуальных прав Администратора, он вправе взыскать с Пользователя штраф в размере 1 000 000 рублей за каждый случай нарушения.',
            },
            {
                type: 'clause',
                id: '7.5',
                text: 'В случае предъявления Администратору претензий/исков/предписаний о нарушении законодательства или прав третьих лиц по вине Пользователя, он принимает на себя обязательства по их самостоятельному урегулированию и возмещению убытков в случае их возникновения.',
            },
        ],
    },
    {
        id: 'section-8',
        title: '8. Ограничение ответственности',
        blocks: [
            {
                type: 'clause',
                id: '8.1',
                text: 'Ответственность Администратора ограничена суммой, оплаченной по выбранному Тарифу.',
            },
            {
                type: 'clause',
                id: '8.2',
                text: 'Администратор не несет ответственность за:',
            },
            {
                type: 'clause',
                id: '8.2.1',
                text: 'соответствие Сайта конкретным целям и ожиданиям Пользователя. Отрицательная субъективная оценка любых третьих лиц также не является основанием считать Сайт некачественным. Сайт предоставляется на условиях «as is»;',
            },
            {
                type: 'clause',
                id: '8.2.2',
                text: 'достижение каких-либо результатов, связанных с использованием Сайта;',
            },
            {
                type: 'clause',
                id: '8.2.3',
                text: 'неисполнение или ненадлежащее исполнение своих обязательств в связи с нарушениями и/или ограничениями в работе интернета или сервера, на базе которого разработан Сайт;',
            },
            {
                type: 'clause',
                id: '8.2.4',
                text: 'ущерб, нанесенный Пользователю в результате несанкционированного использования третьими лицами устройств Пользователя;',
            },
            {
                type: 'clause',
                id: '8.2.5',
                text: 'сохранность платежных данных, передаваемых интернет-эквайрингу;',
            },
            {
                type: 'clause',
                id: '8.2.6',
                text: 'безопасность, функционирование и производительность Сайта;',
            },
            {
                type: 'clause',
                id: '8.2.7',
                text: 'бесперебойную работу Ключа доступа, поскольку эффективность его функционирования зависит от качества и скорости интернет-соединения Пользователя;',
            },
            {
                type: 'clause',
                id: '8.2.8',
                text: 'совместимость Сайта с устройствами, браузерами и операционными системами, используемыми Пользователем;',
            },
            {
                type: 'clause',
                id: '8.2.9',
                text: 'любые убытки, связанные с использованием Сайта, в том числе ущерб, который может быть нанесен устройствам, носителям информации и/или программному обеспечению Пользователя;',
            },
            {
                type: 'clause',
                id: '8.2.10',
                text: 'действия и/или бездействия других Пользователей и третьих лиц на Сайте;',
            },
            {
                type: 'clause',
                id: '8.2.11',
                text: 'действия и/или бездействия поставщиков услуг, в том числе интернет-провайдеров, банков и электронных платежных систем;',
            },
            {
                type: 'clause',
                id: '8.2.12',
                text: 'неисполнение или ненадлежащее исполнение обязательств в результате наступления форс-мажорных обстоятельств. Под форс-мажорными обстоятельствами, помимо установленных законодательством Российской Федерации, понимаются также обстоятельства, не требующие предоставления официальных подтверждений от соответствующих компетентных органов, при которых любой участник гражданского оборота, осуществляющий аналогичную деятельность, не мог бы избежать наступления данных обстоятельств или их последствий;',
            },
            {
                type: 'clause',
                id: '8.2.13',
                text: 'незаконность использования Сайта на территории иностранного государства.',
            },
        ],
    },
    {
        id: 'section-9',
        title: '9. Блокировка доступа',
        blocks: [
            {
                type: 'clause',
                id: '9.1',
                text: 'Администратор вправе в любое время заблокировать доступ к Сайту без предварительного уведомления в случае:',
            },
            {
                type: 'clause',
                id: '9.1.1',
                text: 'нарушения Пользователем Правил и/или законодательства Российской Федерации;',
            },
            {
                type: 'clause',
                id: '9.1.2',
                text: 'распространения информации диффамационного характера об Администраторе и Сайте. В случае сомнений, диффамационность информации определяется Администратором;',
            },
            {
                type: 'clause',
                id: '9.1.3',
                text: 'получения соответствующих требований от государственных органов.',
            },
            {
                type: 'clause',
                id: '9.2',
                text: 'В случае блокировки доступа к Сайту Пользователь вправе обратиться к Администратору и предоставить необходимые разъяснения.',
            },
            {
                type: 'clause',
                id: '9.3',
                text: 'В течение 3 рабочих дней после верификации информации Пользователя Администратор вправе снять блокировку или оставить ее без изменения.',
            },
            {
                type: 'clause',
                id: '9.4',
                text: 'При блокировке доступа неиспользованный период Подписки не компенсируется. Пользователь соглашается с тем, что удержанная сумма является штрафом за несоблюдение Правил и/или законодательства при использовании Сайта.',
            },
        ],
    },
    {
        id: 'section-10',
        title: '10. Разрешение споров',
        blocks: [
            {
                type: 'clause',
                id: '10.1',
                text: 'Стороны разрешают споры через переговоры, а в случае недостижения согласия в рамках переговоров — в претензионном порядке.',
            },
            {
                type: 'clause',
                id: '10.2',
                text: 'Сторона, получившая претензию, обязана предоставить мотивированный ответ в течение 30 дней с даты ее получения.',
            },
            {
                type: 'clause',
                id: '10.3',
                text: 'Администратор не рассматривает претензии:',
            },
            { type: 'clause', id: '10.3.1', text: 'анонимизированные;' },
            { type: 'clause', id: '10.3.2', text: 'не позволяющие идентифицировать Пользователя;' },
            { type: 'clause', id: '10.3.3', text: 'без обоснования предъявляемых требований;' },
            {
                type: 'clause',
                id: '10.3.4',
                text: 'направленные по каналам коммуникации, не предусмотренным в Правилах.',
            },
            {
                type: 'clause',
                id: '10.4',
                text: 'При невозможности урегулировать спор в претензионном порядке он может быть передан в суд по месту нахождения Администратора.',
            },
        ],
    },
    {
        id: 'section-11',
        title: '11. Техническая поддержка',
        blocks: [
            {
                type: 'clause',
                id: '11.1',
                text: 'Администратор оказывает техническую поддержку в отношении Сайта на основании обращений Пользователя.',
            },
            {
                type: 'clause',
                id: '11.2',
                text: 'Обращения принимаются в любое время. Срок решения проблемы зависит от характера обращения и их общего количества.',
            },
            {
                type: 'clause',
                id: '11.3',
                text: 'Все работы в рамках технической поддержки выполняются удаленно.',
            },
            {
                type: 'clause',
                id: '11.4',
                text: 'Администратор вправе в любое время без предварительного уведомления приостановить работу Сайта для проведения профилактических работ.',
            },
            {
                type: 'clause',
                id: '11.5',
                text: 'Администратор не компенсирует время недоступности Сайта.',
            },
        ],
    },
    {
        id: 'section-12',
        title: '12. Персональные данные',
        blocks: [
            {
                type: 'clause',
                id: '12.1',
                text: 'Администратор выполняет обработку данных Пользователей в целях исполнения Правил и согласно требованиям, установленным Федеральным законом «О персональных данных» № 152-ФЗ от 27.07.2006.',
            },
            {
                type: 'clause',
                id: '12.2',
                text: 'Пользователь дает согласие Администратору на обработку данных.',
            },
            {
                type: 'clause',
                id: '12.3',
                parts: [
                    { type: 'text', value: 'Перечень данных, порядок обработки и их защита определяются в ' },
                    { type: 'link', to: '/privacy', value: 'Политике' },
                    { type: 'text', value: '.' },
                ],
            },
        ],
    },
    {
        id: 'section-13',
        title: '13. Коммуникация Сторон',
        blocks: [
            {
                type: 'clause',
                id: '13.1',
                text: 'Стороны используют для связи Сайт (форма обратной связи, электронную почту или другие каналы, указанные на Сайте).',
            },
            {
                type: 'clause',
                id: '13.2',
                text: 'Переписка имеет юридическую силу, в том числе в случае судебного разбирательства. Иные способы обмена информацией и документами являются ненадлежащими.',
            },
            {
                type: 'clause',
                id: '13.3',
                text: 'Сообщение Администратора считается полученным Пользователем в день его отправки.',
            },
        ],
    },
    {
        id: 'section-14',
        title: '14. Промоутинг Сайта',
        blocks: [
            {
                type: 'p',
                text: 'Администратор разрешает Пользователю публиковать рекламные материалы, связанные с Сайтом.',
            },
        ],
    },
    {
        id: 'section-15',
        title: '15. Заключительные положения',
        blocks: [
            {
                type: 'clause',
                id: '15.1',
                text: 'Правила могут быть изменены и/или дополнены Администратором в любое время без предварительного уведомления. Пользователь самостоятельно проверяет Правила на предмет корректировки.',
            },
            {
                type: 'clause',
                id: '15.2',
                text: 'Новая редакция Правил вступает в силу с даты их опубликования на Сайте. Дата публикации указана внизу документа.',
            },
            {
                type: 'clause',
                id: '15.3',
                text: 'Дальнейшее использование Сайта означает согласие Пользователя с новой редакцией Правил.',
            },
            {
                type: 'clause',
                id: '15.4',
                text: 'Если Пользователь не согласен с новой редакцией Правил, он обязуется прекратить использование Сайта.',
            },
            {
                type: 'clause',
                id: '15.5',
                text: 'Если использование Сайта станет незаконным на территории Российской Федерации, Администратор вправе прекратить его работу, уведомив об этом Пользователей минимум за 10 дней. В таком случае перерасчет денежных средств не производится.',
            },
            {
                type: 'clause',
                id: '15.6',
                text: 'Правила регулируются правом Российской Федерации без учета коллизионных норм.',
            },
            {
                type: 'clause',
                id: '15.7',
                text: 'Если какое-либо положение Правил будет признано недействительным или неисполнимым, остальная часть Правил остается в полной силе и действии.',
            },
        ],
    },
    {
        id: 'section-16',
        title: '16. Реквизиты Администратора',
        blocks: [
            { type: 'p', text: 'Хамдохов А.Р.' },
            { type: 'p', text: 'ИНН 070709952572' },
            { type: 'p', text: 'Сайт: bypass-vpn.ru' },
        ],
    },
];

export const TERMS_PUBLISHED_DATE = '10.06.2026';
